import { render, staticRenderFns } from "./ChatbotSorryImage.vue?vue&type=template&id=2e1a0db8&scoped=true&lang=pug&"
import script from "./ChatbotSorryImage.vue?vue&type=script&lang=ts&"
export * from "./ChatbotSorryImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1a0db8",
  null
  
)

export default component.exports